import {
    GET_ALL_SOFTWARE
} from './constants';

const initialState = {
    allSoftware: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_SOFTWARE: {
            return {
                ...state,
                allSoftware: action.payload,
            };
        }
        default:
            return state;
    }
};

